import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toggleIsMobile } from "../../../store/slices/IdSlice";

const PaymentNavbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isFixed, setIsFixed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const handleBackButton = () => {
    navigate(-1);
  };

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
    const che = window.innerWidth < 768;
    dispatch(toggleIsMobile(che));
  };

  useEffect(() => {
    import("./paymentNavbar.css");
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <>
      {!isMobile ? (
        <>
          <div
            className={` small-header fixed-top bg-white p-2 ${
              isFixed ? "fixed" : ""
            }`}
            style={{
              borderBottom: "1px solid #E5E5E5",
            }}
          >
            <div className="container d-flex align-items-center">
              <div
              >
                <img
                  loading="lazy"
                  height={50}
                  width={50}
                  src="https://goodhand.b-cdn.net/Good-Hand-02-vdjwclCG.png"
                  alt="Company Logo"
                  onClick={() => navigate("/")}
                />
              </div>
              <div>
                <p className="font-16 ff-semibold mb-0 text-black ">
                  {location.pathname.slice(1) === "cart"
                    ? "CheckOut"
                    : location.pathname.slice(1)}
                </p>
              </div>
            </div>
          </div>
          <div className="header-height-fix"></div>
        </>
      ) : (
        <div
          className={`mobile-nav d-flex justify-content-between align-items-center small-header fixed-top bg-white p-2 ${
            isFixed ? "fixed" : ""
          }`}
          style={{ borderBottom: "1px solid #E5E5E5" }}
        >
          <div className="d-flex align-items-center gap-3">
            <button className="back-icon" onClick={handleBackButton}>
              <FontAwesomeIcon icon={faArrowLeft} />
            </button>

            <p className="font-16 ff-semibold mb-0 text-black ">
              <>
                {location.pathname.slice(1) === "cart"
                  ? "CheckOut"
                  : location.pathname.slice(1)}
              </>
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default PaymentNavbar;
